module.exports = "/images/jobs.jpg?7ed222fce941080138cc0622967924a3";